import Input from "@components/Input";
import { Row } from "@components/Layout";
import useI18n from "@contexts/I18nProvider/hooks/useI18n";
import useDebounce from "@hooks/useDebounce";
import { For, Show, type VoidComponent, createEffect, createSignal } from "solid-js";
import { OptionsWrapper, SearchWrapper, SelectItem } from "./styled";
import type { AutocompletePlace, SearchProps } from "./types";

const Search: VoidComponent<SearchProps> = (props) => {
	const [options, setOptions] = createSignal<AutocompletePlace[]>([]);
	const [open, setOpen] = createSignal(false);
	let ref: HTMLInputElement | undefined;
	const { t } = useI18n();

	const { value, onValue, debouncedValue } = useDebounce();

	createEffect(async () => {
		const v = debouncedValue();
		if (v.length < 3) return;

		//@ts-ignore
		const { places } = await google.maps.places.Place.searchByText({
			textQuery: v,
			fields: ["displayName", "location", "addressComponents", "adrFormatAddress"],
			language: "cs-CZ",
		});
		setOptions(
			(places as google.maps.places.Place[]).map<AutocompletePlace>((place) => ({
				location: place.location,
				value: place.adrFormatAddress ?? "",
			})),
		);
	});

	return (
		<>
			<SearchWrapper
				onmouseleave={() => {
					setOpen(false);
					ref?.blur();
				}}
			>
				<Input
					ref={ref}
					value={value()}
					onChange={onValue}
					placeholder={t("app.location.address")}
					onfocus={() => setOpen(true)}
				/>
				<Show when={open()}>
					<OptionsWrapper onclick={() => setOpen(false)}>
						<For each={options()}>
							{(o) => (
								<SelectItem
									innerHTML={o.value}
									onclick={() => props.onLocation(o.location as google.maps.LatLng)}
									alignItems="center"
								/>
							)}
						</For>
					</OptionsWrapper>
				</Show>
			</SearchWrapper>

			<Row h="10px" />
		</>
	);
};
export default Search;
